module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"JD卡兑换","tipsDetail":["<special>1. 由于京东服务商城停止运营，后续将不再支持京东卡兑换，可选择提现支付渠道/对公打款。<special>","<special>2. 已兑换过的JD卡请在下方兑换记录中点击 查看卡密 获取。复制卡密后，请打开JD官网（jd.com），登录并在我的钱包中选择礼品卡，输入卡密即可兑换，移动端请点击 我的-我的钱包-礼品卡-绑定新卡 完成操作。<special>"],"tipsTitle":"兑换注意事项"}}')
  delete Component.options._Ctor
}
